import { createResource, For, Show } from "solid-js"
import { useLanguage } from "@/context/language"
import { listOutputRevisions } from "@/datox/api"

export function DatoxRevisionSelect(props: { projectID: string; outputID: string; kind: "report" | "dashboard"; value: number; refreshKey?: string; disabled?: boolean; onChange: (value: number) => void }) {
  const language = useLanguage()
  const [revisions] = createResource(() => `${props.projectID}:${props.kind}:${props.outputID}:${props.refreshKey ?? ""}`,
    () => listOutputRevisions(props.projectID, props.outputID, props.kind))
  const options = () => revisions.error ? [] : (revisions.latest ?? []).filter((item) => item.output_id === props.outputID)
  return <div class="flex min-w-0 max-w-full flex-wrap items-center gap-2 text-12-regular">
    <label class="flex min-w-0 max-w-full items-center gap-2"><span>{language.t("datox.revisions.label")}</span>
      <select data-testid="output-revision-picker" class="min-w-0 max-w-full rounded-md border border-v2-border-border-base bg-v2-background-bg-base px-3 py-2 text-12-regular"
        aria-label={language.t("datox.revisions.label")} value={props.value || ""} disabled={props.disabled || revisions.loading}
        onChange={(event) => props.onChange(Number(event.currentTarget.value) || 0)}>
        <option value="">{language.t("datox.revisions.latest")}</option>
        <For each={options()}>{(item) => <option value={item.number} disabled={item.status !== "completed"}>
          {language.t(item.status === "completed" ? "datox.revisions.option" : "datox.revisions.incomplete", { number: item.number, date: item.created_at.replace("T", " ").slice(0, 16) })}
        </option>}</For>
      </select>
    </label>
    <Show when={revisions.error}><span role="status">{language.t("datox.revisions.error")}</span></Show>
    <Show when={props.value}><span class="text-v2-text-text-muted">{language.t("datox.revisions.readOnly")}</span></Show>
  </div>
}
